import api from '../../../services/api';

export const importService = {
  listAccounts: () => api.get('/sync'),
  addAccount: (accountId: string) => api.post('/sync', { accountId }),
  syncAccount: (accountId: string, token: string) =>
    api.post(`/sync/${accountId}/sync`, { token }),
  syncAll: (token: string) => api.post('/sync/all', { token }),
  queueSync: (email: string) => api.post('/queue/sync', { email }),
  updateAccountName: (accountId: string, accountName: string) =>
    api.patch(`/sync/${accountId}/name`, { accountName }),
  updateAdjustTimezone: (accountId: string, adjustTimezone: boolean) =>
    api.patch(`/sync/${accountId}/adjust-timezone`, { adjustTimezone }),
  updateMonthsBack: (accountId: string, monthsBack: number) =>
    api.patch(`/sync/${accountId}/months-back`, { monthsBack }),
  removeAccount: (accountId: string) => api.delete(`/sync/${accountId}`),
  getImportStatus: () => api.get('/import-status'),
};
